import moment from "moment";

export const formatDateTimeForChat = (input) => {
    input = moment(input);
    let result = moment().isSame(input, "day")
        ? moment(input).format("HH:mm")
        : moment(input).format("DD/MM/YYYY HH:mm");

    return result;
}